import { RegisterOpenReminderController as controller } from './register-open-reminder.controller'
import template from './register-open-reminder.html'

/**
 * RegisterOpenReminder Component
 */
export const RegisterOpenReminderComponent = {
  controller,
  template,
}
